import React, { useState } from "react";
import { Box, Grid } from "@mui/material";
import CustomColorPicker from "../../CustomColorPicker";
import ColorSwatch from "../../Swatch";
import { colors } from "../../../constants/background";

// Preset swatches + free-form picker. Supports BOTH preset selection AND any
// free-form hex value. Identical behavior to LinkVault's original ColorField.
//
// Keyboard/AT parity (WL-024 / ISP-4200): each swatch is a real button role
// with a label, pressed-state and Enter/Space activation — a click-only <Box>
// is unreachable without a mouse. Ported here so EVERY surface built on
// <ThemeEditor> (LinkVault, Gallery, Business Box) inherits it.
const ColorField = ({ value, onChange }) => {
  const [pickerOpen, setPickerOpen] = useState(false);
  const [draft, setDraft] = useState(value || "#FFFFFF");

  const openPicker = () => {
    setDraft(value || "#FFFFFF");
    setPickerOpen(true);
  };

  const activateOnKey = (fn) => (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      fn();
    }
  };

  return (
    <Box>
      <Grid container spacing={1} alignItems="center">
        {colors.map((c, i) => (
          <Grid item key={c}>
            <Box
              data-testid={`color-swatch-${i}`}
              role="button"
              tabIndex={0}
              aria-label={`Color ${c}`}
              aria-pressed={value === c}
              onClick={() => onChange(c)}
              onKeyDown={activateOnKey(() => onChange(c))}
              sx={{
                cursor: "pointer",
                "&:focus-visible": {
                  outline: "2px solid #9B5AF8",
                  outlineOffset: "2px",
                  borderRadius: "50%",
                },
              }}
            >
              <ColorSwatch color={c} borderColor={value === c && "#BBBBBB"} />
            </Box>
          </Grid>
        ))}
        <Grid item>
          <Box
            data-testid="color-custom"
            role="button"
            tabIndex={0}
            aria-label="Custom color"
            onClick={openPicker}
            onKeyDown={activateOnKey(openPicker)}
            sx={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              border: "1px dashed #BBBBBB",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              fontSize: 18,
              color: "#9B5AF8",
              "&:focus-visible": {
                outline: "2px solid #9B5AF8",
                outlineOffset: "2px",
              },
            }}
            title="Custom color"
          >
            +
          </Box>
        </Grid>
      </Grid>
      <CustomColorPicker
        visible={pickerOpen}
        color={draft}
        onColorChange={setDraft}
        onClose={() => setPickerOpen(false)}
        onConfirm={(c) => {
          onChange(c);
          setPickerOpen(false);
        }}
      />
    </Box>
  );
};

export default ColorField;
